import { useState } from 'react'
import classNames from 'classnames'
import { useLocation, useNavigate } from 'react-router-dom'

import { useLanguage } from '../../context/LangaugeContextProvider/LangaugeContextProvider'
import { isArabic, updateClassname } from '../../utils'
import styles from './Footer.module.scss'
import downArrow from '../../assets/images/arrow-down-blue.svg'

function MenuList({ menu = [] }) {
  const navigate = useNavigate()
  const { pathname, state } = useLocation()
  const { language } = useLanguage()
  const [openMenu, setOpenMenu] = useState(null)

  const toggleMenu = (index) => {
    setOpenMenu((prevState) => (prevState === index ? null : index))
  }

  const buttonClickHandler = (selectedPath) => {
    let count = state?.count
    if (
      selectedPath === '/how-it-works/infrastructure-build/upi' &&
      selectedPath === pathname
    ) {
      count = state?.count ? state?.count + 1 : 1
      updateClassname('remove', document.body, 'scroll-disabled')
    }
    navigate(selectedPath, {
      state: { count: count },
    })
    setTimeout(function () {
      window.scrollTo(0, 0)
    }, 100)

    // if (pathname === selectedPath) {
    //   window.scrollTo(0, 0)
    // } else {
    //   navigate(selectedPath)
    // }
  }

  const renderMenuItems = (items) => {
    return (
      items &&
      items.map((item) => (
        <div key={item?.link?.path + item?.id}>
          {item.type === 'link' && (
            <button
              className={'cursor-pointer'}
              onClick={() => buttonClickHandler(item?.link?.path)}
            >
              {item?.link?.label}
            </button>
          )}
        </div>
      ))
    )
  }

  return menu.length ? (
    <div
      className={classNames(styles.listContainer, {
        [styles.arabicListContainer]: isArabic(language?.code),
      })}
    >
      {menu.map((subMenu, index) => (
        <div
          className={styles.subMenuContainer}
          key={subMenu?.link?.path + subMenu?.id}
        >
          {subMenu.type === 'menu' && (
            <>
              <button
                aria-label={subMenu?.link?.label}
                className="cursor-pointer"
                onClick={() => toggleMenu(index)}
              >
                <span className={styles.spanText}>{subMenu?.link?.label}</span>
                <img
                  src={downArrow}
                  alt="Expand"
                  className={classNames({
                    [styles.expanded]: openMenu === index,
                  })}
                />
              </button>
            </>
          )}
          {subMenu.type === 'link' && (
            <button onClick={() => buttonClickHandler(subMenu?.link?.path)}>
              {subMenu?.link?.label}
            </button>
          )}
          {openMenu === index && subMenu.menus.length > 0 && (
            <div className={styles.linkContainer}>
              {renderMenuItems(subMenu.menus)}
            </div>
          )}
        </div>
      ))}
    </div>
  ) : (
    <></>
  )
}

export default MenuList
